import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = "https://connections-api.herokuapp.com";

export const fetchContacts = createAsyncThunk("contacts/fetchAll", async (_, thunkAPI) => {
    try { 
        const response = await axios.get("/contacts");
        return response.data;
    }
    catch(e) {
        return thunkAPI.rejectWithValue(e.message);
    }
}
);

export const addContact = createAsyncThunk("contacts/addContact", async({ name, number }, thunkAPI) => {
    try {
        const response = await axios.post("/contacts", { name, number });
        return response.data;
    }
    catch (e) {
        return thunkAPI.rejectWithValue(e.message);
    }
  
});

export const deleteContact = createAsyncThunk("contacts/deleteContact", async (id, thunkAPI) => {
    try {
        const response = await axios.delete(`/contacts/${id}`);
        return response.data;
    }
    catch (e) {
        return thunkAPI.rejectWithValue(e.message);
    }
})

export const update = createAsyncThunk("contacts/updateContact", async ({id, name, number }, thunkAPI) => {
    try {
        const contact = { id, name, number };
        const response = await axios.patch(`/contacts/${contact.id}`, { name: contact.name, number: contact.number });
        return response.data;
    }
    catch (e) {
        return thunkAPI.rejectWithValue(e.message);
    }
})


